import styled from "styled-components";

import { windowWidth } from "@styles/global";

export const Container = styled.div`
  .dataTables_wrapper {
    margin: 10px;
  }
  .dataTables_length {
    padding-top: 10px;

    label {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 100%;

      select {
        -webkit-appearance: none;
        -moz-appearance: none;
        margin-right: 20px;
        width: 50px;

        option {
          text-align: center;
        }
      }
    }
  }
  .dataTables_search {
    position: relative;
    padding: 10px 10px;
    width: 100%;
    z-index: 2;

    /* Large than any mobile device */
    @media (min-width: ${windowWidth.mobile.large}) {
      padding: 0;

      .dataTables_filter {
        margin-bottom: 10px;
      }
    }

    .dataTables_filter {
      label {
        display: flex;
        align-items: center;

        input {
          width: 100%;
          border-radius: 10px;
        }
      }
    }
  }
  .dataTables_scroll {
    .dataTables_scrollHead {
      background: ${(props) => props.theme.colors.primary};
      color: white;
      border-radius: 10px 10px 0 0;

      /* Large than any mobile device */
      @media (min-width: ${windowWidth.mobile.large}) {
        padding: 5px 0;
      }

      thead tr th {
        border-bottom: none;
      }
    }
    .dataTables_scrollBody {
      height: calc(100vh - 400px) !important;
      max-height: calc(100vh - 400px) !important;
      overflow-x: hidden !important;
      border-radius: 0 0 10px 10px;
      border: 1px solid ${(props) => props.theme.colors.primary};

      table {
        /* Large than any mobile device */
        @media (min-width: ${windowWidth.mobile.large}) {
          td {
            padding: 5px;
          }
        }

        .dataTables_empty {
          height: calc(100vh - 285px);
        }
        .child {
          .dtr-details {
            width: 100%;

            li {
              padding: 5px 0;
              display: flex;
              align-items: center;
              justify-content: space-between;

              .dtr-title {
                min-width: 0;
              }
              .dtr-data {
                text-align: right;
                padding-left: 15px;
              }
            }
          }
        }
      }
    }
  }
  .dataTables_info {
    padding-top: 15px;
  }
  .dataTables_paginate {
    margin-bottom: 10px;
    display: flex;
    padding-top: 5px 0 5px 0;
    justify-content: space-evenly;

    & > span {
      display: flex;
      align-items: center;
    }
    .paginate_button {
      padding: 5px 8px;
    }
  }
  .dataTables_buttons .dt-buttons {
    margin-top: 25px;

    .button:disabled,
    .button[disabled] {
      opacity: 0.7;
      cursor: auto;
    }
    .button {
      min-width: 100px;
      height: 50px;
      background: #707070;
      border-radius: 10px;
      border: 0;
      padding: 14px 10px;
      color: #fff;
      font-weight: 500;
      margin-left: 16px;
      transition: background-color 0.2s;

      &:hover {
        background: rgb(112 112 112 / 0.6);
      }
    }
    .button.MuiButton-root {
      text-transform: inherit;
      line-height: 0.9;
      box-shadow: none;
    }
  }

  .flex--center {
    display: flex;
    justify-content: center;
  }
  .flex--hidden {
    display: none;
  }
  .fixed--bottom {
    width: 100%;
    background: #e0e0e0;
    position: fixed;
    bottom: 0;
    margin-left: -10px;

    /* Large than any mobile device */
    @media (min-width: ${windowWidth.mobile.large}) {
      padding: 20px;
      width: calc(100% - 60px);
    }
  }
`;

export const Buttons = styled.div`
  > :first-child {
    padding: 0 5px 5px 5px;
    bottom: 110px;
    background: white;
    border-radius: 50%;

    > :first-child {
      box-shadow: none;
    }
    > :nth-child(3) {
      bottom: 160px;
    }
  }
`;
